
import React from 'react';
import { Separator } from '@/components/ui/separator';
import CostItem from './CostItem';
import { 
  MonitorIcon, 
  RocketIcon, 
  ListChecksIcon, 
  UsersIcon, 
  HeartPulseIcon 
} from 'lucide-react';

interface CostBreakdownProps {
  costs: {
    platformCost: number;
    appTypeCost: number;
    featuresCost: number;
    userVolumeCost: number;
    maintenanceCost: number;
    total: number;
  };
}

const CostBreakdown: React.FC<CostBreakdownProps> = ({ costs }) => {
  return (
    <div className="bg-muted p-4 rounded-lg">
      <h3 className="text-lg font-medium mb-3">Cost Breakdown</h3>
      <div className="space-y-1">
        <CostItem 
          label="Platforms" 
          amount={costs.platformCost} 
          icon={<MonitorIcon className="h-4 w-4" />} 
        />
        <CostItem 
          label="App Type" 
          amount={costs.appTypeCost} 
          icon={<RocketIcon className="h-4 w-4" />} 
        />
        <CostItem 
          label="Features" 
          amount={costs.featuresCost} 
          icon={<ListChecksIcon className="h-4 w-4" />} 
        />
        <CostItem 
          label="User Volume" 
          amount={costs.userVolumeCost} 
          icon={<UsersIcon className="h-4 w-4" />} 
        />
        {costs.maintenanceCost > 0 && (
          <CostItem 
            label="Maintenance" 
            amount={costs.maintenanceCost} 
            icon={<HeartPulseIcon className="h-4 w-4" />} 
          />
        )}
        <Separator className="my-2" />
        <CostItem 
          label="Total Estimated Cost" 
          amount={costs.total} 
          highlight={true} 
        />
      </div>
    </div>
  );
};

export default CostBreakdown;
